import React, { useContext, useEffect, useState } from "react";
import successIcon from "../../images/successGreenIcon.png";
import errorIcon from "../../images/errorRedIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import { ListDetailsContext } from "../../contexts/ListDetailsContext";
import { UrlContext } from "../../contexts/UrlContext";

export default function ExSummary({
  summary,
  expert_id,
  summLength,
  setSummLength,
  showSummAlert,
  setShowSummAlert,
}) {
  const { tableData, setTableData } = useContext(ListDetailsContext);
  const [value, setValue] = useState("");
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSummCounter, setShowSummCounter] = useState(false);
  const { API_URL } = useContext(UrlContext);
  useEffect(() => {
    setValue(summary);
    setSummLength(summary.length);
  }, [summary]);

  const changeSummary = (newValue) => {
    setReturnError(false);
    setLoading(true);
    setShowSummCounter(true);
    setTimeout(() => {
      setShowSummCounter(false);
    }, 6000);
    setShowSummAlert(false);

    setSummLength(newValue.length);
    const url = `${API_URL}change-summary`;
    const data = {
      expert_id,
      summary: newValue,
    };
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        if (data.status === "success") {
          setReturnSuccess(true);
          setTimeout(() => {
            setReturnSuccess(false);
          }, 1500);
          setTableData(
            tableData.map((item) => {
              if (item.expert.ID === expert_id) {
                item.expert.summ = newValue;
              }
              return item;
            })
          );
        } else {
          setReturnError(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setReturnError(true);
        console.log(err);
      });
  };
  return (
    <>
      <textarea
        placeholder="Summary"
        title="Summary"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={(e) => changeSummary(e.target.value)}
      />
      {showSummAlert && (
        <p className="prjdetails-summ-alert">
          Summary for Zoho: Max. length exceed {summLength}/2000
        </p>
      )}

      {showSummCounter && (
        <p className="prjdetails-summ-count">{summLength}/2000</p>
      )}

      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "-17px" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "-17px" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "6px", right: "-17px" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}
